/**
 * sentry — guarded frontend error tracking.
 *
 * No-ops unless REACT_APP_SENTRY_DSN is set (local dev / prerender stay clean).
 * Keeps capture cheap: errors only, no session replay by default.
 */
import * as Sentry from "@sentry/react";

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initErrorTracking() {
  if (!DSN || typeof window === "undefined") return;
  Sentry.init({
    dsn: DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || "production",
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

export { Sentry };
